import React from "react";
import Skeleton from "react-loading-skeleton";

const EventLisstSkeleton = () => {
  return (
    <div className="row kiosk-row">
      {Array.apply(0, Array(8)).map((n, i) => (
        <div className="col-6" key={i} style={{marginBottom: "19px", lineHeight: 1}}>
          <Skeleton height={182}/>
        </div>
      ))}
    </div>
  );
};

export default EventLisstSkeleton;
